
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, Utente, FinderGruppoLavorazioniPerFase, GruppoLavorazioniPerFase, RangeDescriptor, TextValueItem } from '@/models';
import { store, StoreActions } from '@/store';
import { Loading } from '@/components';
import dayjs from 'dayjs';
import { LoadingTemplateType } from './enums/LoadingTemplateType';
import { filter } from 'vue/types/umd';
import { StringDescriptor } from '@/models/finders/StringDescriptor';
import { StringComparisonOperator } from '@/models/enums/StringComparisonOperator';
import { MultiSelectDescriptor } from '@/models/finders/MultiSelectDescriptor';

@Component({
  components: {
    Loading,
    FilterPopup: () => import('@/components/shared/FilterPopup.vue'),
    ProgressBar: () => import('@/components/shared/ProgressBar.vue')
  }
})
export default class GruppoLavorazionePerFaseTabella extends Vue {
    get page(): number { return store.state.uiGruppoLavorazioniPerFase.pagina; }
    set page(value: number) { this.caricaGruppoLavorazioniPerFase(value); }
    get user() { return store.state.currentUsr; }
    get userIsAdmin() {
        return (
        this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
        undefined
        );
    }
    get itemsPerPage(): number {return store.state.uiGruppoLavorazioniPerFase.dimensionePaginaListe }
    get pageCount(): number { return store.state.uiGruppoLavorazioniPerFase.totPagine; }
    get numTotOrdini(): number { return store.state.uiGruppoLavorazioniPerFase.totGruppi; }

    get loading () {
        return store.state.uiGruppoLavorazioniPerFase.loadingGruppoLavorazioniPerFase;
    }

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return LoadingTemplateType.DataTable;
    }

    filters: any = {}
    get dataSourceFasi(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerFaseDataSource.dataSourceFasi;
    }
    
    get dataSourceStagioni(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerFaseDataSource.dataSourceStagioni;
    }

    get headers(): any[] {
        return [
            {
                text: "Progresso",
                value: "Progresso",
                align: 'center',
                sortable: false
            },
            {
                text: "Fase",
                value: "Fase",
                align: 'center',
                sortable: false,
                /*filter: {
                    type: 'string',
                    field: 'fase'
                }*/
                filter: {
                    type: 'multiselect',
                    field: 'fase',
                    dataSource: this.dataSourceFasi    
                }
            },
            {
                text: "Stagione",
                value: "Stagione",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'stagione',
                    dataSource: this.dataSourceStagioni
                }
            },
            {
                text: "Capi lanciati",
                value: "Capi lanciati",
                align: 'center',
                sortable: false,
                /*filter: {
                    type: 'number',
                    field: 'capiLanciati'
                }*/
            },
            {
                text: "Capi rientrati",
                value: "Capi rientrati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Carico Capi",
                value: "Carico Capi",
                align: 'center',
                sortable: false,
            }
        ];
    }
    get fornitore(): Utente | undefined {
        return store.state.fornitore;
    }
    private idFornitore: string = '';
    async created() {
        if (this.userIsAdmin) {
            if(this.fornitore){
                this.idFornitore = this.fornitore.id;
                await this.caricaDataSources();
                this.caricaGruppoLavorazioniPerFase(1);
            }
        } else {
            this.idFornitore = this.user.idFornitore;
            await this.caricaDataSources();
            this.caricaGruppoLavorazioniPerFase(1);
        }
    }

    private caricaGruppoLavorazioniPerFase(pagina: number): void {
        let parametri: FinderGruppoLavorazioniPerFase = {
            numeroPagina: pagina,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: store.state.uiGruppoLavorazioniPerFase.dimensionePaginaListe,
            fase: "", //TODO valorizzare da filtro, se necessario,
        }


        if( this.filters["fase"] && this.filters["fase"].filter &&  this.filters["fase"].filter.length){
            //parametri.filtroFase = new StringDescriptor(this.filters["fase"].operator, this.filters["fase"].filter);
            parametri.filtroFase = new MultiSelectDescriptor(this.filters["fase"].operator, this.filters["fase"].filter);
        }

        if( this.filters["stagione"] && this.filters["stagione"].filter &&  this.filters["stagione"].filter.length){
            parametri.filtroStagione = new MultiSelectDescriptor(this.filters["stagione"].operator, this.filters["stagione"].filter);
        }

        if( this.filters["capiLanciati"]){
            parametri.filtroCapiLanciati = new RangeDescriptor(this.filters["capiLanciati"].operator, this.filters["capiLanciati"].filter);
        }

        store.dispatch(StoreActions.GetGruppoLavorazioniPerFase, parametri);
    }

    private async caricaDataSources() {
        let parametri: FinderGruppoLavorazioniPerFase = {
            numeroPagina: 0,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: 0,
            fase: "", //TODO valorizzare da filtro, se necessario,
        }
        await store.dispatch(StoreActions.GetGruppoLavorazioniPerFaseDataSources, parametri)
    }

    get items(): GruppoLavorazioniPerFase[] {
        return store.state.uiGruppoLavorazioniPerFase.gruppoLavorazioniPerFase;
    }

    onSetfilter(filterItem : any) {
        this.filters[filterItem.field] = {operator: filterItem.operator, filter: filterItem.filter};
        this.caricaGruppoLavorazioniPerFase(1);
    }

    onRemoveFilter(filterItem : any) {
        delete this.filters[filterItem.field];
        this.caricaGruppoLavorazioniPerFase(1);
    }

    @Watch("$store.state.fornitore")
    onCambioFiltri() {
        this.idFornitore = store.state.fornitore?.id ?? "";
        this.caricaGruppoLavorazioniPerFase(store.state.uiGruppoLavorazioniPerFase.pagina);
    }
}

